<app-default-layout [showBackToLanding]="true">
  <div class="container content">
    <div class="row">
      <div class="col-md-12">
        <div [innerHtml]="body"></div>
      </div>
    </div>
  </div>
</app-default-layout>
